import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import AppButton from '../../Components/MerchantButton';
import './UnifiedFormStyles.css';

const SQRBrandingVersion = ({ navigation }) => {
  const [branding, setBranding] = useState('');
  const [standeeCount, setStandeeCount] = useState('');

  const handleBack = () => {
    navigation.previous();
  };

  const handleNext = () => {
    if (!branding) {
      toast.error('Please select a branding version', { autoClose: 2500, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (!standeeCount || !standeeCount.trim()) {
      toast.error('Please enter SQR standee count or note', { autoClose: 2500, hideProgressBar: true, theme: 'colored' });
      return;
    }
    if (navigation && navigation.next) navigation.next();
  };


  const options = [
    { key: 'green-bird', label: '2.0', img: 'https://via.placeholder.com/220x140?text=Green+Bird' },
    { key: 'v1-5', label: '1.5', img: 'https://via.placeholder.com/220x140?text=Version+1.5' },
    { key: 'damaged', label: 'old design - green bird', img: 'https://via.placeholder.com/220x140?text=Damaged' },
    { key: 'others', label: 'custom', img: 'https://via.placeholder.com/220x140?text=Other' },
  ];

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">SQR Standee Branding</h4>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">SQR Standee Branding</Form.Label>
                    <Form.Text className="form-note-text d-block text-start mb-3">
                      Always check for "Powered by MAYA" at the bottom of the SQR.
                    </Form.Text>
                    <div className="form-radio-group">
                      {options.map((opt, index) => (
                        <div key={`sqr-brand-${index}-${opt.key}`} className="mb-4">
                          <div className={`form-radio-item${branding === opt.key ? " selected" : ""}`}>
                            <div className="form-radio-flex">
                              <Form.Check
                                type="radio"
                                name="sqr_brand"
                                id={`sqr_brand_${opt.key}`}
                                value={opt.key}
                                label={opt.label}
                                checked={branding === opt.key}
                                onChange={(e) => setBranding(e.target.value)}
                                className="form-radio"
                              />
                            </div>
                          </div>
                          <div className="text-center">
                            <img
                              src={opt.img}
                              alt={`${opt.label} example`}
                              className="img-fluid rounded shadow-sm img-max-240"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    <div>
                      <p className="form-note-text">
                        <em>"Note: Always check for "POWERED BY MAYA" at the bottom of the SQR"</em>
                      </p>
                    </div>
                  </Form.Group>


                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      SQR Standee Count <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Text className="form-note-text d-block text-start">1. Get insight why SQR is still not updated.</Form.Text>
                    <Form.Text className="form-note-text d-block text-start mb-2">2. Advise merchant to escalate request for SQR update.</Form.Text>
                    <Form.Control
                      type="text"
                      value={standeeCount}
                      onChange={(e) => setStandeeCount(e.target.value)}
                      placeholder="Show Answer Text"
                      className="form-input"
                    />
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SQRBrandingVersion;

